module.exports = __webpack_public_path__ + "static/media/stofferingen-16.d3880ab4.jpg";